<template>
    <div class="stage-highlight" :style="`color: ${color}`">
        <div class="top">
            <div class="icon">
                <i :class="`dfcicon-${icon}`"></i>
            </div>
            <div class="title">{{ title }}</div>
        </div>
        <div class="line">
            <div class="line-color" :style="`background: ${color}`"></div>
        </div>
        <div class="content">
            <markdown-text :content="content"/>
        </div>
    </div>
</template>

<script>
import MarkdownText from "@/Components/Common/MarkdownText";
export default {
    name: "StageHighlight",
    components: {MarkdownText},
    props: ['icon', 'title', 'content', 'color'],

}
</script>

<style lang="scss" scoped>

.stage-highlight{
    text-align: center;

    &:hover{
        .top{
            padding: 0 0 1rem;
        }
        .line-color{
            width: 100%;
        }
        .content{
            opacity: 1;
        }
    }
}

.top{
    padding: 1rem 0 0;
    transition: padding .5s;
}

.icon{
    font-size: 2.4rem;
    line-height: 1;
    margin-bottom: 0.7rem;
}

.title{
    font-size: 1.4rem;
    font-weight: $font-weight-bolder;
    margin-bottom: 1rem;
}

.line{
    background: lighten($dark, 60%);
    height: 2px;
    border-radius: 6px;
    margin-bottom: 1rem;
}

.line-color{
    height: 2px;
    border-radius: 6px;
    width: 0;
    transition: width .5s;
}

.content{
    color: $dark;
    font-size: 0.8rem;
    opacity: 0;
    transition: opacity .5s;
}
</style>
